"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "agoraScreenShareStopped", {
  enumerable: true,
  get: function get() {
    return _agoraScreenShareStopped["default"];
  }
});
var _agoraScreenShareStopped = _interopRequireDefault(require("./agoraScreenShareStopped"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }